import React, { useState } from 'react';
import { Form, Input, Button } from 'antd';
import { useSelector } from 'react-redux';
import { apiCall } from '../../API/RestApi';
import { modalError, modalSuccess } from '../../Component/Modal/ModalLayout';

const ChangePassword = () => {
  const token = useSelector((state) => state.user.token);
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);

  const onFinish = (values) => {
    setLoading(true);
    callApi('POST', '/changepassword', values);
  };

  const callApi = (method, url, values) => {
    const dataReq = {
      method,
      url,
      data: {
        data: values,
        headers: {
          Authorization: 'Bearer ' + token,
        },
      },
    };
    apiCall(dataReq)
      .then((res) => {
        if (res.status === 'success') {
          setLoading(false);
          form.resetFields();
          modalSuccess(res.message);
        } else {
          modalError(res.message);
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };

  return (
    <>
      <h4>Change Password</h4>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          name="password_old"
          label="Current Password"
          rules={[
            {
              required: true,
              message: 'Please enter your current password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="password_new"
          label="New Password"
          rules={[
            {
              required: true,
              message: 'Please enter a new password!',
            },
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item
          name="password_confirm"
          label="Confirm New Password"
          dependencies={['password_new']}
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Please confirm your new password!',
            },
            ({ getFieldValue }) => ({
              validator(_, value) {
                if (!value || getFieldValue('password_new') === value) {
                  return Promise.resolve();
                }
                return Promise.reject(new Error('Password confirmation does not match!'));
              },
            }),
          ]}
        >
          <Input.Password />
        </Form.Item>

        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default ChangePassword;